import "./Product.css";
import { useEffect, useState } from "react";
import axios from "axios";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { addProduct } from "../Redux/shoppingCartSlice";
import NavBar from "./NavBar";

import CategoryProducts from "./AllProducts";
import { ToastContainer, toast } from "react-toastify";

import "react-toastify/dist/ReactToastify.css";

import teaPot from "../images/teaPot.svg";
import clock from "../images/clock.svg";
import termometer from "../images/termometer.svg";

function Product() {
  const shoppingCart = useSelector((state) => state.shoppingCart);
  const params = useParams();
  const dispatch = useDispatch();
  const [product, setProduct] = useState(null);
  const [count, setCount] = useState(0);
  const [isShownDesc, setIsShownDesc] = useState(true);
  const [isShownIng, setIsShownIng] = useState(false);
  const [productCategory, setProductCategory] = useState();

  const notify = () => toast.success("Product added to cart");

  const showDescription = () => {
    setIsShownDesc(true);
    setIsShownIng(false);
  };
  useEffect(() => {
    const products = async () => {
      const response = await axios.get(
        `${process.env.REACT_APP_URL_BACK}/product/${params.slug}`
      );

      setProduct(response.data);
      setProductCategory(response.data.categoryId);
    };

    products();
  }, [params.slug]);

  const contador = () => {
    setCount(count + 1);
  };
  const addNewItem = () => {
    dispatch(addProduct(product));
  };

  const productInCart = product
    ? shoppingCart.find((element) => element.id === product.id)
    : null;

  return (
    product && (
      <div>
        <NavBar />
        <div className="product container pt-5 mt-5">
          <div className="row">
            <div className="col-sm-12 col-md-8 col-lg-6">
              <img
                src={`
              ${process.env.REACT_APP_FILES_URL}/${product.image}
            `}
                className="productImage col-12"
                alt="Te Negro"
              />
            </div>
            <div className="mt-5 text-start col-sm-12 col-md-8 col-lg-6 productInfo">
              <p>
                <small>
                  <span className="me-2">Home</span>/
                  <span className="me-2 ms-2">Category</span>/
                  <span className="ms-2">{product.name} </span>
                </small>
              </p>
              <h3 className="fw-bold pt-2 pb-2">{product.name}</h3>
              <div>
                <ul className="d-flex justify-content-start m-0 p-0 mb-3">
                  <li
                    type="button"
                    className="border-bottom  description me-3 "
                    onClick={showDescription}
                    style={isShownIng ? { color: "grey" } : { color: "black" }}
                  >
                    Description
                  </li>
                </ul>
                <div>{isShownDesc ? <p> {product.description}</p> : ""}</div>
              </div>

              <p className="description"></p>
              <span className="price  d-block">US$ {product.price}</span>

              {productInCart ? (
                <span
                  className={`d-block mt-1 fs-5 ${
                    product.stock - productInCart.quantity > 0
                      ? "text-success"
                      : "text-danger"
                  }`}
                >
                  Stock :{" "}
                  {product.stock - productInCart.quantity >= 0
                    ? product.stock - productInCart.quantity
                    : 0}
                </span>
              ) : (
                <span className="d-block mt-1 fs-5 text-success">
                  Stock : {product.stock}
                </span>
              )}

              {productInCart ? (
                <button
                  className={`btn btn-dark mt-3 fw-bold ${
                    product.stock - productInCart.quantity < 1 && "d-none"
                  }`}
                  onClick={() => {
                    addNewItem();
                    contador();
                    notify();
                  }}
                >
                  Add to cart
                </button>
              ) : (
                <button
                  className="btn btn-dark mt-3 fw-bold"
                  onClick={() => {
                    addNewItem();
                    contador();
                    notify();
                  }}
                >
                  Add to cart
                </button>
              )}

              <ToastContainer
                position="top-right"
                autoClose={1000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
              />
            </div>

            <div className="container">
              <div className="row">
                {product.categoryId === 2 ? (
                  <div className="row">
                    <div className="col-lg-4 ">
                      <div className="d-flex flex-column">
                        <img src={clock} alt="" className="clock" />
                        <span>Steep Time </span>
                        <span>3'</span>
                      </div>
                    </div>
                    <div className="col-lg-4 ">
                      <div className="d-flex flex-column">
                        <img src={termometer} alt="" className="termometer" />
                        <span>Water Temp </span>
                        <span>boiling</span>
                      </div>
                    </div>
                    <div className="col-lg-4 ">
                      <div className="d-flex flex-column">
                        <img src={teaPot} alt="" className="teaPot" />
                        <span>Dosage </span>
                        <span>1 teabag</span>
                      </div>
                    </div>
                  </div>
                ) : (
                  ""
                )}
                <div className="col-8 col-lg-10"></div>
                <div className="col-4 col-lg-2"></div>
              </div>
            </div>
          </div>
        </div>
        <CategoryProducts productCategory={productCategory} />
      </div>
    )
  );
}

export default Product;
